import React from "react";
import { Field } from 'redux-form/immutable';
import { SelectField } from 'redux-form-antd';
import {
    required, nullValue0
} from '../../validDesc';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
}

const ClubThursdaySelect = props => {
    const club_monday_select = [
        {
            label: '-- 請選擇 --',
            value: '0'
        },
        {
            value: '434',
            label: '4:50自接'
        },
        {
            value: '400',
            label: '安親1-2年級'
        },
        {
            value: '411',
            label: '游泳1-4年級(1.5H)'
        },
        {
            value: '412',
            label: '籃球1-2年級'
        },
        {
            value: '413',
            label: '跆拳道1-4年級'
        },
        {
            value: '414',
            label: 'MV舞蹈1-4年級'
        },
        {
            value: '415',
            label: 'Scratch電腦程式設計初階1-2年級'
        },
        {
            value: '417',
            label: '自然科學1年級'
        },
        {
            value: '423',
            label: '直排輪初階1-3年級'
        },
        {
            value: '424',
            label: '西洋棋進階1-3年級'
        },
        {
            value: '425',
            label: '樂高物理機械1-3年級(1H)'
        },
        {
            value: '428',
            label: '鋼琴'
        },
        {
            value: '429',
            label: '小提琴'
        },
    ]
    const club_thursday_display_options = club_monday_select.map(item => (
        item.value === '0' ? item : { ...item, label: `[${item.value}]${item.label}` }
    ));
    return (
        <div>
             <Field {...formItemLayout} validate={[required, nullValue0]} component={SelectField} label="星期四"
                options={club_thursday_display_options} name="club_thursday" type="text"></Field>
        </div>
    )
}

export default ClubThursdaySelect



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/StudentClubForm/ClubThursdaySelect.jsx